import Nullstack from 'nullstack';
export default function IconCodeOff({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-code-off",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("path", {
    d: "M7 8l-4 4l4 4"
  }), "   ", Nullstack.element("path", {
    d: "M17 8l4 4l-2.5 2.5"
  }), "   ", Nullstack.element("path", {
    d: "M14 4l-1.201 4.805m-.802 3.207l-1.997 7.988"
  }), "   ", Nullstack.element("path", {
    d: "M3 3l18 18"
  }), " ");
}